<template>
  <section class="testimonials-section" id="testimonials">
    <div class="container">
      <div class="row">
        <div class="col-md-4 mb-4" v-for="(review, index) in reviews" :key="index">
          <div class="testimonial-card fade-in-up" :class="`delay-${index + 1}`">
            <div class="card-body">
              <div class="stars mb-3">
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star-half-alt"></i>
              </div>
              <p class="review-text">"{{ review.text }}"</p>
              <div class="reviewer-info">
                <div class="avatar">
                  <span>{{ review.initials }}</span>
                </div>
                <div class="info">
                  <h5 class="name">{{ review.name }}</h5>
                  <span class="date">{{ review.date }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TestimonialsSection',
  data() {
    return {
      reviews: [
        {
          name: 'Marco Rossi',
          initials: 'MR',
          date: '10 Novembre 2025',
          text: 'Applicazione fantastica! Finalmente posso gestire i miei scontrini senza impazzire. Il codice lotteria è sempre a portata di mano.'
        },
        {
          name: 'Laura Bianchi',
          initials: 'LB',
          date: '15 Novembre 2025',
          text: 'Semplice, veloce e intuitiva. La funzione delle liste della spesa condivise è utilissima per la famiglia. Consigliatissima!'
        },
        {
          name: 'Giuseppe Verdi',
          initials: 'GV',
          date: '8 Novembre 2025',
          text: 'Ottima app, fa esattamente quello che deve fare. Niente pubblicità invasiva e interfaccia pulita. 5 stelle meritate.'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables";

.testimonials-section {
  padding: 100px 0;
  background-color: #f8f9fc; // Grigio chiaro per alternanza elegante

  .section-title {
    font-size: 2.5rem;
    font-weight: 700;
    color: #1a1a1a;
    margin-bottom: 1rem;
  }

  .section-subtitle {
    color: #666;
    font-size: 1.1rem;
    max-width: 600px;
    margin: 0 auto;
  }

  .testimonial-card {
    background: #ffffff;
    border-radius: 16px;
    padding: 2rem;
    box-shadow: none;
    height: 100%;
    transition: all 0.3s ease;
    border: 1px solid #e8eaef;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 12px 32px rgba(30, 60, 114, 0.08);
      border-color: rgba($theme-primary, 0.2);
    }

    .stars {
      color: #ffc107;
      font-size: 0.9rem;
    }

    .review-text {
      color: $gray-dark;
      font-style: italic;
      margin-bottom: 1.5rem;
      line-height: 1.6;
    }

    .reviewer-info {
      display: flex;
      align-items: center;
      gap: 1rem;

      .avatar {
        width: 45px;
        height: 45px;
        background: linear-gradient(135deg, $theme-primary, $theme-secondary);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-weight: 600;
        font-size: 1rem;
      }

      .info {
        .name {
          font-size: 1rem;
          font-weight: 700;
          margin: 0;
          color: $gray-darker;
        }
        .date {
          font-size: 0.8rem;
          color: $gray-light;
        }
      }
    }
  }
}

.fade-in-up {
  animation: fadeInUp 0.8s ease-out forwards;
  opacity: 0;
  transform: translateY(20px);
}

.delay-1 { animation-delay: 0.2s; }
.delay-2 { animation-delay: 0.4s; }
.delay-3 { animation-delay: 0.6s; }

@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
